import { render, staticRenderFns } from "./model-theme.vue?vue&type=template&id=e10ae312"
import script from "./model-theme.vue?vue&type=script&lang=js"
export * from "./model-theme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports